import { Pipe, LOCALE_ID, Inject } from '@angular/core';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth.service';

import { Product } from '@models/product';
import { Vendor } from '@models/vendor';
import { getInventoryStatusSortRank } from '@classes/inventory-aging';

export interface InventoryRowLike {
  product: Product;
  formGroup?: { value: Product };
}

export class ProductSort {

  constructor() {

  }

  static setFilterPredicate(dataSource:MatTableDataSource<FormGroup>, selection:SelectionModel<FormGroup>) {
    dataSource.filterPredicate = ((data: FormGroup, filterString: string) => {
      let filterStringArr = filterString.split('$');
      let filter = filterStringArr[0];
      let stockOption = filterStringArr[1];
      filter = ProductSort.escapeRegExp(filter);
      let reg = new RegExp(filter, 'i');
      if (stockOption == 'stock') {
        return data.value.status != 'return' && data.value.status != 'returned' && (data.value.quantity > 0 && (!filter || reg.test(data.value.model) || reg.test(data.value.color) || selection.selected.includes(data) || data.value._id == 'NEW'));
      } else if (stockOption == 'return') {
        return (data.value.status == 'return' || data.value.status == 'returned') && (!filter || reg.test(data.value.model) || reg.test(data.value.color) || selection.selected.includes(data) || data.value._id == 'NEW');
      } else if (!filter) {
        return data.value.status != 'return' && data.value.status != 'returned' && (reg.test(data.value.model) || reg.test(data.value.color) || selection.selected.includes(data) || data.value._id == 'NEW');
      } else {
        // return data.value.status != 'return' && data.value.status != 'returned' && (!filter || reg.test(data.value.model) || selection.selected.includes(data) || data.value._id == 'NEW');
        return reg.test(data.value.model) || reg.test(data.value.color) || selection.selected.includes(data) || data.value._id == 'NEW';
      }
    });
  }

  static escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  static filterProductStock(dataSource:MatTableDataSource<FormGroup>, productsForm:FormGroup) {
    dataSource.filter = productsForm.get('search').value.trim().toUpperCase() + '$' + productsForm.get('showStock').value;
  }

  static setSorter(dataSource:MatTableDataSource<FormGroup>, sort:MatSort, vendor?: Vendor) {
    dataSource.sortingDataAccessor = (item, property) => {
      if (!item.value[property]) {
        item.value[property] == '';
      }
      switch(property) {
        case 'vendor':
          if (item.value.vendor) {
            let vendor: Object = item.value.vendor;
            return vendor['name'].toUpperCase();
          } else {
            return '';
          }
          break;
        case 'model':
          return item.value.model;
          break;
        case 'color':
          return item.value.color;
          break;
        case 'size':
          return item.value.size;
          break;
        case 'status':
          return getInventoryStatusSortRank(
            {
              status: item.value.status,
              lastInvoiceDate: item.value.lastInvoiceDate,
            },
            vendor
          );
          break;
        case 'type':
          return item.value.type;
          break;
        case 'cost':
          return item.value.cost;
          break;
        case 'retail':
          return item.value.retail;
          break;
        case 'quantity':
          return item.value.quantity;
          break;
        case 'images':
          return item.value.images.length;
          break;
        default:
          return item.value[property].toUpperCase();
      }
    };
    dataSource.sort = sort;
  }

  static setInventoryRowSorter(
    dataSource: MatTableDataSource<InventoryRowLike>,
    sort: MatSort,
    vendor?: Vendor
  ) {
    dataSource.sortingDataAccessor = (row, property) => {
      const value = (row.formGroup?.value ?? row.product) as Product;
      if (!value[property]) {
        value[property] == '';
      }
      switch(property) {
        case 'vendor':
          if (value.vendor) {
            const vendor: Object = value.vendor;
            return vendor['name'].toUpperCase();
          } else {
            return '';
          }
        case 'model':
          return value.model;
        case 'color':
          return value.color;
        case 'size':
          return value.size;
        case 'status':
          return getInventoryStatusSortRank(
            {
              status: value.status,
              lastInvoiceDate: row.product?.lastInvoiceDate ?? value.lastInvoiceDate,
            },
            vendor
          );
        case 'type':
          return value.type;
        case 'cost':
          return value.cost;
        case 'retail':
          return value.retail;
        case 'quantity':
          return value.quantity;
        case 'images':
          return (value.images || []).length;
        default:
          return value[property]?.toUpperCase?.() ?? value[property];
      }
    };
    dataSource.sort = sort;
  }
}
